import $ from 'jquery'
const httpHead = {
	'privatekey': 'akewhgjkhrg564654',
    'apparatus': 'Android',
    'version': '2.1',
    'machine': 'MI6',
    'token': '131346413663'
}
// console.log(httpHead)
//const apiUrl = 'http://www.heshumedia.com/'
const apiUrl = 'http://www.heshumedia.com/'
const resourceUrl = 'http://www.heshumedia.com/upload/'
let appshow = true;
let setSEO = function (data) {
	document.title = data.title;
	$("meta[name='keywords']").attr('content',data.keywords);
	$("meta[name='description']").attr('content',data.description);
}
let getCookie = function (data,arg){
	let val = data.split('; ');
	let cookieObj = {};
	for (let i = 0;i<val.length;i++){
		let arr = val[i].split('=');
		cookieObj[arr[0]] = arr[1]
	}
	return cookieObj[arg];
}
export {
	httpHead,
	apiUrl,
	resourceUrl,
	setSEO,
	appshow,
	getCookie
}


// WEBPACK FOOTER //
// ./src/common/util/config.js